<template>
  <div class="cashflow-category-menu-items">
    <card-menu-item v-if="showEditPredictedIncome"
                    item-key="edit"
                    :onItemClick="openEditPredictedIncomePopup"
                    :icon-src="require('@/assets/icons/gray-pencil.svg')"
                    text="לעדכן צפי הכנסות משתנות"/>
    <card-menu-item item-key="info"
                    :onItemClick="emitOpenTrend"
                    :icon-src="require('@/assets/icons/gray-graph-bars.svg')"
                    :text="trendsMenuItemText"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import cashflowViewConsts from '@/constants/cashflow-view';
import BaseUI from 'base-ui';
import Segment from '../../../../../../../../../../Segment';
import CashflowTrends from '../../../../cashflow-trend/CashflowTrendsMixin';
import { TREND_COMPONENTS } from '../../../../cashflow-trend/cashflow-trends';
import predictedIncomeConsts from '../edit-predicted-income/consts';
import EditPredictedIncomePopup from '../edit-predicted-income/EditPredictedIncomePopup';
import PredictedIncomeInfoPopup from '../edit-predicted-income/PredictedIncomeInfoPopup';

export default {
  name: 'CashflowIncomeSectionMenu',
  components: {
    CardMenuItem: BaseUI.CardMenuItem,
  },
  mixins: [CashflowTrends],
  computed: {
    ...mapGetters('featureFlags', ['showEditPredictedIncome']),
    wasInfoPopupDisplayed() {
      return Boolean(localStorage.getItem(predictedIncomeConsts.INFO_POPUP_DISPLAYED_KEY));
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    emitOpenTrend() {
      this.openModal({ component: TREND_COMPONENTS[cashflowViewConsts.cashflowTypes.income] });
    },
    openEditPredictedIncomePopup() {
      Segment.trackUserInteraction('SectionMenu_openEditPredictedIncomePopup_Clicked', {
        trackingCategory: this.categoryName,
      });
      this.openModal({
        component: this.wasInfoPopupDisplayed ? EditPredictedIncomePopup : PredictedIncomeInfoPopup,
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.cashflow-category-menu-items {
  display: contents;
}

</style>
